import React from 'react';
import PropTypes from 'prop-types';
import { Container, GridItem } from '@chakra-ui/react';
import { DeptGrid } from '@rsc/ui-components/dept/design-system';
import CardBlogStandard from '@rsc/ui-components/dept/atoms/CardBlogStandard';

export default function CardRowTwoUp({ block }) {
  return (
    <Container pt={[8, null, 20]} pb={[14, null, 20]}>
      <DeptGrid gridRowGap={6}>
        <GridItem colSpan={[6, null, 8]}>
          <CardBlogStandard
            badge={block.cards[0]?.badge}
            article={block.cards[0]?.postReference}
          />
        </GridItem>
        <GridItem colSpan={[6, 6, null, 4]}>
          <CardBlogStandard
            badge={block.cards[1]?.badge}
            article={block.cards[1]?.postReference}
          />
        </GridItem>
      </DeptGrid>
    </Container>
  );
}

CardRowTwoUp.propTypes = {
  block: PropTypes.shape({
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        badge: PropTypes.shape({
          headline: PropTypes.string,
          copy: PropTypes.string,
          link: PropTypes.shape({
            linkType: PropTypes.string,
            href: PropTypes.string,
            internalLink: PropTypes.shape({
              slug: PropTypes.shape({
                current: PropTypes.string,
              }),
            }),
          }),
          icon: PropTypes.shape({
            asset: PropTypes.shape({
              url: PropTypes.string,
            }),
          }),
        }),
        postReference: PropTypes.shape({
          _id: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          articleType: PropTypes.string,
          categories: PropTypes.arrayOf(
            PropTypes.shape({
              _key: PropTypes.string,
              title: PropTypes.string,
            })
          ).isRequired,
          image: PropTypes.shape({
            asset: PropTypes.shape({
              url: PropTypes.string.isRequired,
            }),
            alt: PropTypes.string,
          }).isRequired,
          author: PropTypes.shape({
            title: PropTypes.string.isRequired,
            slug: PropTypes.shape({
              current: PropTypes.string.isRequired,
            }).isRequired,
          }),
          slug: PropTypes.shape({
            current: PropTypes.string.isRequired,
          }).isRequired,
        }),
      })
    ).isRequired,
  }).isRequired,
};
